import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'out-type',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './type.component.html',
  styleUrl: './type.component.scss',
})
export class TypeComponent implements OnInit, OnDestroy {
  imageSrc = 'for-sale.webp';
  private routeSub!: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.setImageBasedOnUrl();
    this.routeSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setImageBasedOnUrl();
      }
    });
  }

  setImageBasedOnUrl(): void {
    const currentUrl = this.router.url;
    if (currentUrl.endsWith('for-sale')) {
      this.imageSrc = 'for-sale.webp';
    } else if (currentUrl.endsWith('lease-takeover')) {
      this.imageSrc = 'lease-takeover.webp';
    } else {
      this.imageSrc = 'sale-pending.webp';
    }
  }

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  pillItems = [
    { label: 'For Sale', url: '/categories/type/for-sale' },
    { label: 'Lease Takeover', url: '/categories/type/lease-takeover' },
    { label: 'Sale Pending', url: '/categories/type/sale-pending' },
  ];
}
